import { adminAuthAxios, authAxios } from './appAxios';

export const getAPIResponse = async (url, config) => {
  return new Promise((resolve, reject) => {
    authAxios
      .get(url, config)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const getAdminAPIResponse = async (url, config) => {
  return new Promise((resolve, reject) => {
    adminAuthAxios
      .get(url, config)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const postAPIResponse = async (url, obj, config) => {
  return new Promise((resolve, reject) => {
    authAxios
      .post(url, obj, config)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const adminPostAPIResponse = async (url, obj, config) => {
  return new Promise((resolve, reject) => {
    adminAuthAxios
      .post(url, obj, config)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const putAPIResponse = async (url, obj, config) => {
  return new Promise((resolve, reject) => {
    authAxios
      .put(url, obj)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

// axios expects obj to be { data: your-obj-here }
export const deleteAPIResponse = async (url, obj) => {
  const data = { data: obj };
  return new Promise((resolve, reject) => {
    authAxios
      .delete(url, data)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
